/**
 * Format a timestamp as a relative "time ago" string in Bahasa Indonesia.
 * - < 1 minute  → "baru saja"
 * - < 60 minutes → "X menit lalu"
 * - < 24 hours  → "X jam lalu"
 * - < 7 days    → "X hari lalu"
 * - < 4 weeks   → "X minggu lalu"
 * - else        → absolute date (DD MMM YYYY)
 */
export function timeAgo(ts: number, now: number = Date.now()): string {
    if (!ts || ts <= 0) return '';
    const diff = Math.max(0, now - ts);
    const sec = Math.floor(diff / 1000);
    if (sec < 60) return 'baru saja';
    const min = Math.floor(sec / 60);
    if (min < 60) return `${min} menit lalu`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr} jam lalu`;
    const day = Math.floor(hr / 24);
    if (day < 7) return `${day} hari lalu`;
    const wk = Math.floor(day / 7);
    if (wk < 4) return `${wk} minggu lalu`;
    // Absolute date
    try {
        const d = new Date(ts);
        return d.toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch {
        return new Date(ts).toISOString().slice(0, 10);
    }
}
